import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { SimpleUser } from "@/orval/gen/model/simpleUser"
import { getSimpleUsersWithNames } from "@/orval/gen"

const loader = new DataLoader<number, SimpleUser | null>(
  async (keys) => {
    const results = await getSimpleUsersWithNames({
      userIds: [...keys],
    })
    return keys.map((key) => results.find((x) => x.userId === key) ?? null)
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimpleUser(userId: number | null | undefined) {
  return useQuery({
    queryKey: ["SimpleUser", userId],
    queryFn: () => loader.load(userId!!),
    enabled: !!userId,
  })
}

/**
 * Fetch a single simple user by ID (using the same dataloader).
 * Used for fetching selected items in infinite selects.
 */
export async function fetchSimpleUserById(
  userId: string | number
): Promise<SimpleUser | null> {
  const numUserId = typeof userId === "string" ? parseInt(userId, 10) : userId
  return loader.load(numUserId)
}
